/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IInsuranceClaimItem } from 'app/shared/model/insurance-claim-item.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IHospitalBill } from 'app/shared/model/hospital-bill.model';
import { ProcessStatus } from 'app/shared/model/enumerations/process-status.model';

export interface IProvidedItem {
  id?: string;
  price?: number | null;
  dateOfServed?: number | null;
  numberOfConsumptions?: number | null;
  status?: keyof typeof ProcessStatus | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  claimItem?: IInsuranceClaimItem | null;
  patient?: IGlucoUser | null;
  bill?: IHospitalBill | null;
}

export const defaultValue: Readonly<IProvidedItem> = {
  active: false,
};
